import { jsx as _jsx } from "react/jsx-runtime";
import { NavLink } from 'react-router-dom';
const FilterLink = ({ filter, children }) => _jsx(NavLink, { to: filter === 'SHOW_ALL' ? '/' : `/${filter}`, children: children });
export default FilterLink;
